import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading, text, buttons" theme="dark" hasCodeBlock className='bgBlue code-block-button-padding' mdxType="TextBlock" />
    <h5 {...{
      "id": "menu--tool-options"
    }}>{`MENU & TOOL OPTIONS`}</h5>
    <p>{`Programmatically enable or disable the comments pane, toolbars, print, and download options`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/document-services/docs/overview/pdf-embed-api/howtos_ui/#menu-and-tool-options"
        }}>{`See documentation`}</a></li>
    </ul>
    <CodeBlock slots="heading, code" repeat="1" languages="JSON, CURL, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "html"
    }}>{`HTML`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div id="adobe-dc-view"></div>
<script src="https://acrobatservices.adobe.com/view-sdk/viewer.js"></script>
<script type="text/javascript">
  document.addEventListener("adobe_dc_view_sdk.ready", function () {
    var adobeDCView = new AdobeDC.View({clientId: "<YOUR_CLIENT_ID>", divId: "adobe-dc-view"});
    adobeDCView.previewFile({
      content:{location: {url: "https://acrobatservices.adobe.com/view-sdk-demo/PDFs/Bodea Brochure.pdf"}},
      metaData:{fileName: "Bodea Brochure.pdf"}
    }, {"showAnnotationTools": true, "showDownloadPDF": false});
  });
</script>
`}</code></pre>
    {/*
     <TextBlock slots="buttons"  theme="dark" className='bgBlue'/>
     - [Get free cretentials](/src/pages/gettingstarted.md) */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      